export enum CustomFlags {
  ParsingString = 0x1,
  TagActive = 0x2,
}
